import VKIcon from '../../assets/icons/VKIcon.svg';
import TGIcon from '../../assets/icons/TGIcon.svg';
import INSTIcon from '../../assets/icons/INSTIcon.svg';

function Location() {
  return ( 
    <div className="location" id='location'>
      <div className="location__left">
        <h2 className="location__left-title">ГДЕ НАЙТИ НАС</h2>
        <div className="location__left-info">
          <p className="location__left-address">
            <span className="location__left-strong">Адрес: </span>
            г. Сургут, проспект Мира, 55</p>
          <p className="location__left-address">
            <span className="location__left-strong">Время работы: </span>
            с 09:00 до 21:00</p>
          <p className="location__left-address">
            <span className="location__left-strong">Телефон: </span>
            +7 (912) 816-01-07</p>
        </div>
      </div>
      <div className="location__right">
        <h3 className="location__right-title">НАШИ СОЦ. СЕТИ</h3>
        <div className="location__right-info">
          <a href='https://vk.com/aqua_time_surgut86' className="location__right-social">
            <p className="location__right-text">Вконтакте</p>
            <img className="location__right-img" src={VKIcon} alt="вк" />
          </a>
          <a href='https://t.me/AQUA_TIME_86' className="location__right-social">
            <p className="location__right-text">Телеграм</p>
            <img className="location__right-img" src={TGIcon} alt="тг" />
          </a>
        </div>
      </div>



      <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ae4adced954ab82b541e050d9951963c7595bed5fa1e55491989262f6b6ae5048&amp;source=constructor" title="AquaTime" width="1530" height="560" frameBorder="0" className="location__map"></iframe>
    </div>
   );
}

export default Location;